import React from 'react'

function SendWebphoneDataTOCRM() {
  return (
    <div>SendWebphoneDataTOCRM</div>
  )
}

export default SendWebphoneDataTOCRM